module.exports = __webpack_public_path__ + "static/media/trashIcon.3422911a.svg";